import { HTMLAttributes, TableHTMLAttributes, TdHTMLAttributes } from 'react'

import cn from '@/utils/tailwind/cn'

import TableHead from './TableHead'

const TableRoot = ({
  className,
  ...props
}: TableHTMLAttributes<HTMLTableElement>) => (
  <table
    className={cn('min-w-full border border-gray-200', className)}
    {...props}
  />
)

export const TableBody = ({
  className,
  ...props
}: HTMLAttributes<HTMLTableSectionElement>) => (
  <tbody className={cn('bg-white', className)} {...props} />
)

export const TableColumn = ({
  className,
  ...props
}: TdHTMLAttributes<HTMLTableDataCellElement>) => (
  <td
    className={cn(
      'border-b border-gray-200 py-2.5 pl-6 pr-3 text-xs font-medium leading-5 text-gray-700/95 md:text-sm',
      className
    )}
    {...props}
  />
)

type TrProps = {
  muted?: boolean
  disabled?: boolean
} & HTMLAttributes<HTMLTableRowElement>

export const TableRow = ({ className, disabled, muted, ...props }: TrProps) => {
  const trStyles = {
    'opacity-25': disabled,
    'bg-gray-50': muted,
  }
  return (
    <tr
      className={cn(
        'transition-300 h-16 transition-opacity ease-in-out',
        trStyles,
        className
      )}
      {...props}
    />
  )
}

export const TableTitle = ({
  className,
  ...props
}: TableHTMLAttributes<HTMLDivElement>) => (
  <div
    className={cn(
      'flex w-full items-center justify-center border-l border-r border-t border-gray-200 bg-gray-50 px-6 py-3 text-center text-xs text-txt-emphasis md:text-base',
      className
    )}
    {...props}
  />
)

export const TableZentake = {
  Root: TableRoot,
  Body: TableBody,
  Column: TableColumn,
  Head: TableHead,
  Row: TableRow,
  Title: TableTitle,
}
